module.exports = __webpack_public_path__ + "static/img/Body-14.840c3197.jpg";